/* Conflict map page: GDELT news places + NASA FIRMS thermal anomalies (+ AIS ships, UCDP events when present).
   Reads conflicts.json (written by conflicts.py) and conflict-geo.json (outlines). A "World" tab gives the overview;
   every map can be zoomed (buttons, Ctrl+scroll, double-click, pinch) and panned (drag). */
(function () {
    const root = document.querySelector('[data-conflict-map]');
    if (!root) return;

    const NS = 'http://www.w3.org/2000/svg';
    const WORLD = 'world';
    const tabsEl = root.querySelector('[data-cm-tabs]');
    const layersEl = root.querySelector('[data-cm-layers]');
    const mapEl = root.querySelector('[data-cm-map]');
    const detailEl = root.querySelector('[data-cm-detail]');
    const listEl = root.querySelector('[data-cm-list]');
    const sideTitle = root.querySelector('[data-cm-sidetitle]');
    const updatedEl = root.querySelector('[data-cm-updated]');
    const spanEl = root.querySelector('[data-cm-timespan]');
    const shipsNote = root.querySelector('[data-cm-shipsnote]');
    const lightsNote = root.querySelector('[data-cm-lightsnote]');
    const lightsCredit = root.querySelector('[data-cm-lightscredit]');
    const lightsBase = root.getAttribute('data-lights') || '';
    let lights = null;   // {ext, views[]} once the night-lights images are confirmed to exist on the server

    let geo = null, data = null, ships = null, region = WORLD, selectedKey = null;
    let view = null, scalers = [], svgEl = null, curGeo = null;
    const layers = { news: true, heat: true, ucdp: true, ships: false, lights: false, onlyCorr: false };
    const SHIP_CLASSES = { t: 'Tanker', c: 'Cargo', o: 'Other vessel', u: 'Type unknown' };
    const MAX_ZOOM = 14;

    function svg(tag, attrs, parent) {
        const n = document.createElementNS(NS, tag);
        for (const k in attrs) n.setAttribute(k, attrs[k]);
        if (parent) parent.appendChild(n);
        return n;
    }
    function h(tag, cls, text, parent) {
        const n = document.createElement(tag);
        if (cls) n.className = cls;
        if (text != null) n.textContent = text;
        if (parent) parent.appendChild(n);
        return n;
    }
    function ago(iso) {
        const t = Date.parse(iso);
        if (isNaN(t)) return '';
        const m = Math.max(0, Math.round((Date.now() - t) / 60000));
        if (m < 2) return 'just now';
        if (m < 60) return m + ' min ago';
        const hr = Math.round(m / 60);
        return hr < 48 ? hr + ' h ago' : Math.round(hr / 24) + ' d ago';
    }
    function px(g, lat, lon) {
        const b = g.bbox;
        return [(lon - b[1]) / (b[3] - b[1]) * g.W, (b[2] - lat) / (b[2] - b[0]) * g.H];
    }
    function inRegion(r, lat, lon) {
        const b = r.bbox;
        return lat >= b[0] && lat <= b[2] && lon >= b[1] && lon <= b[3];
    }
    function safeUrl(u) { return /^https?:\/\//i.test(u) ? u : null; }
    function shortPlace(p) { return (p || '').split(',').slice(0, 2).join(',').trim() || 'Unnamed place'; }
    function geoFor(id) { return id === WORLD ? geo.world : geo.regions[id]; }

    // ---------- data per tab ----------
    function shipsIn(r) {   // r = region geo, or null for the whole world
        const out = { vessels: 0, zones: [], list: [] };
        if (!ships || !ships.zones) return out;
        ships.zones.forEach(function (z) {
            const list = (z.ships || []).filter(function (v) { return !r || inRegion(r, v[0], v[1]); });
            if (!list.length) return;
            out.vessels += z.vessels || list.length;
            out.zones.push(z.name);
            out.list = out.list.concat(list);
        });
        return out;
    }
    function tabData(id) {
        const r = id === WORLD ? null : geo.regions[id];
        function f(arr) { return (arr || []).filter(function (p) { return !r || inRegion(r, p[0], p[1]); }); }
        return {
            news: f(data.news && data.news.points),
            heat: f(data.heat && data.heat.points),
            ucdp: f(data.ucdp && data.ucdp.points),
            ships: shipsIn(r)
        };
    }

    // ---------- tabs and layer toggles ----------
    function buildTabs() {
        tabsEl.textContent = '';
        [WORLD].concat(Object.keys(geo.regions)).forEach(function (id) {
            const d = tabData(id);
            const b = h('button', 'gh-cm-tab' + (id === region ? ' is-active' : ''), null, tabsEl);
            b.type = 'button';
            b.setAttribute('role', 'tab');
            b.setAttribute('aria-selected', id === region ? 'true' : 'false');
            h('span', null, id === WORLD ? 'World' : geo.regions[id].name, b);
            h('span', 'gh-cm-tabn', String(d.news.length + d.heat.length), b);
            if (d.ships.vessels) {
                const sb = h('span', 'gh-cm-tabships', '⚓ ' + d.ships.vessels, b);
                sb.title = d.ships.vessels + ' vessels near ' + d.ships.zones.join(', ');
            }
            b.addEventListener('click', function () { selectRegion(id); });
        });
    }
    function selectRegion(id) { region = id; selectedKey = null; view = null; render(); }

    function buildLayers() {
        layersEl.textContent = '';
        const defs = [['news', 'News mentions', 'news'], ['heat', 'Thermal anomalies', 'heat']];
        if (data.ucdp) defs.push(['ucdp', 'UCDP events', 'ucdp']);
        if (ships) defs.push(['ships', 'Ships (AIS)', 'ships']);
        if (lights) defs.push(['lights', 'Night lights', 'lights']);
        defs.forEach(function (d) {
            const l = h('label', 'gh-cm-layer gh-cm-layer-' + d[2], null, layersEl);
            const c = h('input', null, null, l);
            c.type = 'checkbox';
            c.checked = layers[d[0]];
            h('i', 'gh-cm-swatch', null, l);
            h('span', null, d[1], l);
            c.addEventListener('change', function () { layers[d[0]] = c.checked; render(); });
        });
        const l = h('label', 'gh-cm-layer', null, layersEl);
        const c = h('input', null, null, l);
        c.type = 'checkbox';
        c.checked = layers.onlyCorr;
        h('span', null, 'Heat near news only', l);
        c.addEventListener('change', function () { layers.onlyCorr = c.checked; render(); });
    }

    // ---------- zoom and pan ----------
    function zoomLevel() { return curGeo.W / view.w; }
    function applyView() {
        const g = curGeo;
        view.w = Math.min(g.W, Math.max(g.W / MAX_ZOOM, view.w));
        view.h = view.w * g.H / g.W;
        view.x = Math.min(g.W - view.w, Math.max(0, view.x));
        view.y = Math.min(g.H - view.h, Math.max(0, view.y));
        svgEl.setAttribute('viewBox', view.x + ' ' + view.y + ' ' + view.w + ' ' + view.h);
        const k = zoomLevel();
        for (let i = 0; i < scalers.length; i++) scalers[i](k);   // keep markers and labels the same size on screen
        svgEl.style.touchAction = k > 1.01 ? 'none' : 'pan-y';
        svgEl.classList.toggle('is-zoomed', k > 1.01);
        const rb = mapEl.querySelector('[data-cm-reset]');
        if (rb) rb.disabled = k <= 1.01;
    }
    function toSvg(clientX, clientY) {
        const pt = svgEl.createSVGPoint();
        pt.x = clientX; pt.y = clientY;
        const m = svgEl.getScreenCTM();
        return m ? pt.matrixTransform(m.inverse()) : { x: view.x + view.w / 2, y: view.y + view.h / 2 };
    }
    function zoomAt(factor, cx, cy) {
        const nw = Math.min(curGeo.W, Math.max(curGeo.W / MAX_ZOOM, view.w / factor));
        const r = nw / view.w;
        view.x = cx - (cx - view.x) * r;
        view.y = cy - (cy - view.y) * r;
        view.w = nw;
        applyView();
    }
    function zoomCenter(factor) { zoomAt(factor, view.x + view.w / 2, view.y + view.h / 2); }

    function wireInteraction(stage) {
        const ptrs = new Map();
        let moved = false, last = null, pinch = 0;
        svgEl.addEventListener('wheel', function (e) {
            if (!(e.ctrlKey || e.metaKey)) return;       // plain scrolling keeps scrolling the page
            e.preventDefault();
            const p = toSvg(e.clientX, e.clientY);
            zoomAt(e.deltaY < 0 ? 1.25 : 0.8, p.x, p.y);
        }, { passive: false });
        svgEl.addEventListener('dblclick', function (e) {
            const p = toSvg(e.clientX, e.clientY);
            zoomAt(2, p.x, p.y);
        });
        svgEl.addEventListener('pointerdown', function (e) {
            if (e.pointerType === 'mouse' && e.button !== 0) return;
            ptrs.set(e.pointerId, { x: e.clientX, y: e.clientY });
            moved = false;
            last = { x: e.clientX, y: e.clientY };
            if (ptrs.size === 2) pinch = pinchDist();
        });
        window.addEventListener('pointermove', function (e) {
            if (!ptrs.has(e.pointerId) || !svgEl.isConnected) return;
            ptrs.set(e.pointerId, { x: e.clientX, y: e.clientY });
            if (ptrs.size === 2) {
                const d = pinchDist();
                if (pinch && d) {
                    const a = Array.from(ptrs.values());
                    const p = toSvg((a[0].x + a[1].x) / 2, (a[0].y + a[1].y) / 2);
                    zoomAt(d / pinch, p.x, p.y);
                }
                pinch = d; moved = true;
                return;
            }
            if (zoomLevel() <= 1.01) return;
            const dx = e.clientX - last.x, dy = e.clientY - last.y;
            if (!moved && Math.abs(dx) + Math.abs(dy) < 4) return;
            moved = true;
            const rect = svgEl.getBoundingClientRect();
            const scale = Math.max(view.w / rect.width, view.h / rect.height);   // svg units per pixel (letterbox safe)
            view.x -= dx * scale; view.y -= dy * scale;
            last = { x: e.clientX, y: e.clientY };
            svgEl.classList.add('is-dragging');
            applyView();
        });
        function up(e) {
            ptrs.delete(e.pointerId);
            pinch = 0;
            if (!ptrs.size) svgEl.classList.remove('is-dragging');
        }
        window.addEventListener('pointerup', up);
        window.addEventListener('pointercancel', up);
        svgEl.addEventListener('click', function (e) {   // a drag must not count as a click on a marker
            if (moved) { e.stopPropagation(); e.preventDefault(); moved = false; }
        }, true);
        function pinchDist() {
            const a = Array.from(ptrs.values());
            return a.length < 2 ? 0 : Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y);
        }

        const ctl = h('div', 'gh-cm-zoom', null, stage);
        [['+', 'Zoom in', function () { zoomCenter(1.6); }], ['−', 'Zoom out', function () { zoomCenter(1 / 1.6); }]].forEach(function (b) {
            const btn = h('button', null, b[0], ctl);
            btn.type = 'button'; btn.title = b[1]; btn.setAttribute('aria-label', b[1]);
            btn.addEventListener('click', b[2]);
        });
        const rs = h('button', 'gh-cm-zoom-reset', '↺', ctl);
        rs.type = 'button'; rs.title = 'Reset view'; rs.setAttribute('aria-label', 'Reset view'); rs.setAttribute('data-cm-reset', '');
        rs.addEventListener('click', function () { view = { x: 0, y: 0, w: curGeo.W, h: curGeo.H }; applyView(); });
        h('div', 'gh-cm-hint', 'Drag to pan · Ctrl + scroll, double-click or pinch to zoom', stage);
    }

    // ---------- drawing ----------
    function drawMap(d) {
        const world = region === WORLD;
        const g = geoFor(region);
        curGeo = g;
        scalers = [];
        mapEl.textContent = '';
        const stage = h('div', 'gh-cm-stage', null, mapEl);
        const s = svg('svg', { viewBox: '0 0 ' + g.W + ' ' + g.H, class: 'gh-cm-svg', role: 'img',
            'aria-label': g.name + ' conflict map' }, stage);
        svgEl = s;
        s.style.aspectRatio = g.W + ' / ' + g.H;
        view = view || { x: 0, y: 0, w: g.W, h: g.H };
        const u = world ? 0.6 : 1;   // marker size factor: the world map is much more zoomed out

        svg('path', { d: g.land, class: 'gh-cm-land', 'fill-rule': 'evenodd' }, s);
        if (layers.lights && lights && lights.views.indexOf(region) !== -1) {
            // NASA Black Marble image for exactly this view's bounding box (static file made by fetch-blackmarble.py)
            s.classList.add('has-lights');
            svg('image', { href: lightsBase + region + '.' + lights.ext, x: 0, y: 0, width: g.W, height: g.H,
                preserveAspectRatio: 'none', class: 'gh-cm-lights' }, s);
        }
        svg('path', { d: g.borders, class: 'gh-cm-borders' }, s);

        function dot(tag, attrs, base, extra) {   // circle whose radius is constant on screen at any zoom
            const n = svg(tag, attrs, s);
            scalers.push(function (k) { n.setAttribute('r', (base / k).toFixed(2)); });
            return n;
        }
        function label(x, y, text, cls, size, dx) {
            const t = svg('text', { x: x, y: y, class: cls }, s);
            t.textContent = text;
            scalers.push(function (k) { t.style.fontSize = (size / k).toFixed(2) + 'px'; t.setAttribute('x', x + dx / k); t.setAttribute('y', y + 3.5 / k); });
            return t;
        }

        if (world) {
            Object.keys(geo.regions).forEach(function (id) {
                const r = geo.regions[id], a = px(g, r.bbox[2], r.bbox[1]), b = px(g, r.bbox[0], r.bbox[3]);
                const box = svg('rect', { x: a[0], y: a[1], width: b[0] - a[0], height: b[1] - a[1], class: 'gh-cm-regbox',
                    tabindex: 0, role: 'button', 'aria-label': 'Open ' + r.name }, s);
                const t = svg('title', {}, box);
                t.textContent = r.name + ' – click to open';
                box.addEventListener('click', function () { selectRegion(id); });
                box.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectRegion(id); } });
            });
        } else {
            g.labels.forEach(function (l) {
                const p = px(g, l[1], l[2]);
                dot('circle', { cx: p[0], cy: p[1], class: 'gh-cm-city' }, 2);
                label(p[0], p[1], l[0], 'gh-cm-citylabel', 11, 5);
            });
        }

        if (layers.ships) {
            d.ships.list.forEach(function (v, i) {
                const xy = px(g, v[0], v[1]);
                const cls = SHIP_CLASSES[v[2]] ? v[2] : 'u';
                const c = dot('circle', { cx: xy[0], cy: xy[1], class: 'gh-cm-ship is-' + cls, tabindex: 0, role: 'button',
                    'aria-label': (v[4] || 'Vessel') + ', ' + SHIP_CLASSES[cls] }, 2.3 * u);
                bind(c, 's' + i, function () { showShip(v, cls); });
            });
        }
        if (layers.heat) {
            d.heat.forEach(function (p, i) {
                if (layers.onlyCorr && !p[4]) return;
                const xy = px(g, p[0], p[1]);
                const key = 'h' + i;
                const c = dot('circle', { cx: xy[0], cy: xy[1], class: 'gh-cm-heat' + (p[4] ? ' is-corr' : '') +
                    (key === selectedKey ? ' is-sel' : ''), tabindex: 0, role: 'button',
                    'aria-label': 'Thermal anomaly, ' + ago(p[3]) }, (2.6 + Math.min(3, Math.sqrt(p[2]) / 3)) * u);
                bind(c, key, function () { showHeat(p); });
            });
        }
        if (layers.ucdp) {
            d.ucdp.forEach(function (p, i) {
                const xy = px(g, p[0], p[1]);
                const key = 'u' + i;
                const base = (3 + Math.min(7, Math.sqrt(p[2] || 1))) * u;
                const c = svg('rect', { class: 'gh-cm-ucdp' + (key === selectedKey ? ' is-sel' : ''), tabindex: 0, role: 'button', 'aria-label': 'UCDP event' }, s);
                scalers.push(function (k) {
                    const r = base / k;
                    c.setAttribute('x', xy[0] - r); c.setAttribute('y', xy[1] - r); c.setAttribute('width', r * 2); c.setAttribute('height', r * 2);
                });
                bind(c, key, function () { showUcdp(p); });
            });
        }
        if (layers.ships && d.ships.list.length) shipLegend();
        if (layers.news) {
            d.news.forEach(function (p, i) {
                const xy = px(g, p[0], p[1]);
                const key = 'n' + i;
                const base = world ? Math.min(13, 3.5 + 1.3 * Math.sqrt(p[2])) : Math.min(26, 5 + 2.4 * Math.sqrt(p[2]));
                const c = dot('circle', { cx: xy[0], cy: xy[1], class: 'gh-cm-news' + (key === selectedKey ? ' is-sel' : ''),
                    tabindex: 0, role: 'button', 'aria-label': shortPlace(p[3]) + ', ' + p[2] + ' mentions' }, base);
                bind(c, key, function () { showNews(p); });
            });
        }
        wireInteraction(stage);
        applyView();
    }

    function shipLegend() {
        const ul = h('ul', 'gh-cm-shiplegend', null, mapEl);
        [['t', 'Tankers'], ['c', 'Cargo'], ['o', 'Other'], ['u', 'Type unknown']].forEach(function (c) {
            const li = h('li', null, null, ul);
            h('i', 'gh-cm-swatch gh-cm-ship is-' + c[0], null, li);
            h('span', null, c[1], li);
        });
    }

    function bind(node, key, fn) {
        function go() { selectedKey = key; fn(); }
        node.addEventListener('click', go);
        node.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); }
        });
    }

    // ---------- detail card ----------
    function detailOpen(title, sub) {
        detailEl.hidden = false;
        detailEl.textContent = '';
        const x = h('button', 'gh-cm-detail-x', '×', detailEl);
        x.type = 'button';
        x.setAttribute('aria-label', 'Close');
        x.addEventListener('click', function () { detailEl.hidden = true; selectedKey = null; });
        h('strong', 'gh-cm-detail-title', title, detailEl);
        if (sub) h('div', 'gh-cm-detail-sub', sub, detailEl);
    }
    function showNews(p) {
        detailOpen(shortPlace(p[3]), p[2] + ' mention' + (p[2] === 1 ? '' : 's') + ' in the last ' + (data.news.timespan || '6h').replace('h', ' hours'));
        const ul = h('ul', 'gh-cm-links', null, detailEl);
        (p[4] || []).forEach(function (l) {
            const u = safeUrl(l[1]);
            if (!u) return;
            const a = h('a', null, l[0], h('li', null, null, ul));
            a.href = u; a.target = '_blank'; a.rel = 'noopener noreferrer nofollow';
        });
        if (!ul.children.length) h('li', 'gh-cm-nolinks', 'Headlines not available for this point.', ul);
    }
    function showHeat(p) {
        detailOpen('Thermal anomaly', 'Detected ' + ago(p[3]) + ' · power ' + p[2] + ' MW');
        h('p', 'gh-cm-detail-p', p[4]
            ? 'Within 15 km of a place named in conflict news. A reason to look closer, not proof of an attack.'
            : 'No matching place in recent conflict news. Could be a wildfire, agricultural burning or an industrial fire.', detailEl);
    }
    function showShip(v, cls) {
        detailOpen(v[4] || 'Unnamed vessel', SHIP_CLASSES[cls] + (v[3] != null ? ' · ' + v[3] + ' knots' : ''));
        h('p', 'gh-cm-detail-p', 'Position from AIS, last 30 minutes. Shown for context near a chokepoint, not as evidence of an incident.', detailEl);
    }
    function showUcdp(p) {
        detailOpen('UCDP event', (p[3] || '') + (p[2] ? ' · ' + p[2] + ' reported deaths' : ''));
        if (p[4]) h('p', 'gh-cm-detail-p', String(p[4]), detailEl);
    }

    // ---------- side list ----------
    function placeItem(p, d) {
        const li = h('li', 'gh-cm-item', null, listEl);
        const b = h('button', 'gh-cm-itembtn', null, li);
        b.type = 'button';
        h('span', 'gh-cm-itemplace', shortPlace(p[3]), b);
        h('span', 'gh-cm-itemn', String(p[2]), b);
        if (p[4] && p[4][0]) h('span', 'gh-cm-itemhead', p[4][0][0], b);
        b.addEventListener('click', function () {
            selectedKey = 'n' + d.news.indexOf(p);
            showNews(p);
            detailEl.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        });
    }
    function drawList(d) {
        listEl.textContent = '';
        if (region === WORLD) {
            sideTitle.textContent = 'Monitored regions';
            Object.keys(geo.regions).map(function (id) {
                const x = tabData(id);
                return { id: id, x: x, score: x.news.reduce(function (a, p) { return a + p[2]; }, 0) + x.heat.length * 3 };
            }).sort(function (a, b) { return b.score - a.score; }).forEach(function (r) {
                const li = h('li', 'gh-cm-item', null, listEl);
                const b = h('button', 'gh-cm-itembtn', null, li);
                b.type = 'button';
                h('span', 'gh-cm-itemplace', geo.regions[r.id].name, b);
                const heatCorr = r.x.heat.filter(function (p) { return p[4]; }).length;
                h('span', 'gh-cm-itemhead', r.x.news.length + (r.x.news.length === 1 ? ' place' : ' places') + ' in the news · ' + r.x.heat.length + (r.x.heat.length === 1 ? ' heat point' : ' heat points') +
                    (heatCorr ? ' (' + heatCorr + ' near news)' : ''), b);
                b.addEventListener('click', function () { selectRegion(r.id); });
            });
            if (!data.news && !data.heat) h('li', 'gh-cm-empty', 'No data available at the moment.', listEl);
            return;
        }
        sideTitle.textContent = 'In the news · ' + geo.regions[region].name;
        const items = d.news.slice().sort(function (a, b) { return b[2] - a[2]; }).slice(0, 12);
        if (!items.length) {
            h('li', 'gh-cm-empty', data.news ? 'No places named in conflict news here right now.' : 'The news layer is unavailable at the moment.', listEl);
            return;
        }
        items.forEach(function (p) { placeItem(p, d); });
    }

    function render() {
        if (!geo || !data) return;
        buildTabs();
        buildLayers();
        const d = tabData(region);
        drawMap(d);
        drawList(d);
        detailEl.hidden = true;
        const parts = [];
        if (data.news) parts.push('News ' + ago(data.news.updated));
        if (data.heat) parts.push('Thermal ' + ago(data.heat.updated)); else parts.push('Thermal layer off');
        if (ships && layers.ships) parts.push('Ships ' + ago(ships.updated));
        updatedEl.textContent = 'Updated: ' + parts.join(' · ');
        if (shipsNote) shipsNote.hidden = !(ships && layers.ships);
        if (lightsNote) lightsNote.hidden = !(lights && layers.lights);
        if (lightsCredit) lightsCredit.hidden = !(lights && layers.lights);
        if (data.news && data.news.timespan) spanEl.textContent = data.news.timespan.replace(/h$/, ' hours');
    }

    // ---------- loading ----------
    function loadShips() {
        return fetch(root.dataset.ships, { cache: 'no-store' }).then(function (r) { if (!r.ok) throw 0; return r.json(); })
            .then(function (j) { ships = j && j.zones ? j : null; }).catch(function () { /* ships are optional */ });
    }
    let lightsTried = false;
    function loadLights() {   // static images: look once. If index.json is missing the layer simply never appears.
        if (lightsTried || !lightsBase) return Promise.resolve();
        lightsTried = true;
        return fetch(lightsBase + 'index.json').then(function (r) { if (!r.ok) throw 0; return r.json(); })
            .then(function (j) {
                if (j && /^(png|jpg)$/.test(j.ext) && Array.isArray(j.views)) lights = j;
            }).catch(function () { /* night lights are optional */ });
    }
    function loadConflicts() {
        fetch(root.dataset.feed, { cache: 'no-store' }).then(function (r) { if (!r.ok) throw 0; return r.json(); })
            .then(function (j) {
                data = j;
                if (region !== WORLD && !geo.regions[region]) region = WORLD;
                const keep = view;       // a refresh must not throw away the viewer's zoom
                render();
                if (keep && curGeo && keep.w <= curGeo.W) { view = keep; applyView(); }
            }).catch(function () {
                mapEl.textContent = '';
                h('p', 'gh-cm-empty', 'Conflict data is not available right now. Please check back shortly.', mapEl);
            });
    }
    function load() {
        (root.dataset.ships ? loadShips() : Promise.resolve()).then(loadLights).then(loadConflicts);
    }

    fetch(root.dataset.geo).then(function (r) { return r.json(); }).then(function (j) {
        geo = j;
        load();
        setInterval(function () { if (!document.hidden) load(); }, (parseInt(root.dataset.refresh, 10) || 600) * 1000);
    });
})();
